<template>
  <div class="enclosure">
      <div class="wrapper-box">
        <div class="items-box" v-for="(lists,index) in enclosureList" :key="index">
          <div class="title">{{lists.accthName}}</div>
          <div class="img-box">
            <img :src="lists.accthPath" alt class="imgs"  @click="onDialogOpen(lists.accthPath)"/>
          </div>
        </div>
        </div>
    </div>
</template>
<script>
    import { ImagePreview } from 'vant';
    export default {
        components: {
        },

        data () {
            return {
                enclosureList: []
            };
        },

        computed: {},

        watch: {},

        methods: {
            onDialogOpen (imgUrl) {
                ImagePreview({
                    images: [imgUrl],
                    onClose () {
                        // do something
                    }
                })
            }
        },
        mounted () {
            if (this.$route.query.list) {
                console.log('this.$route.query.list:', this.$route.query.list)
                this.enclosureList = JSON.parse(this.$route.query.list)
            } else if (localStorage.travelEnclosureData) {
                this.enclosureList = JSON.parse(localStorage.travelEnclosureData)
            }
            // if (localStorage.travelEnclosureData) {
            //     this.enclosureList = JSON.parse(localStorage.travelEnclosureData)
            // }
        },
        created () {}
    };
</script>
<style scoped lang="less">
.enclosure {
  width: 100%;
  min-height: 100%;
  background: rgba(251, 251, 251, 1);
  .wrapper-box {
    box-sizing: border-box;
    padding: 20px 12px 0 12px;

    .items-box {
      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
        margin-bottom: 12px;
      }

      .img-box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .imgs {
          width: 100px;
          height: 100px;
          border-radius: 3px;
          background: #ccc;
          margin-bottom: 25px;

          &:nth-of-type(3n + 2) {
            margin-left: 25px;
            margin-right: 25px;
          }
        }
      }
    }
  }
  .empty-page{
    box-sizing: border-box;
    padding-top: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .ic-img{
      width: 74px;
      height: 62px;
      margin-bottom: 24px;
    }

    .texts{
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:14px;
    }
  }
}
</style>
